import React from 'react';
import { GENRES } from '../data/constants';
import './GenreSelector.css';

export default function GenreSelector({ selectedGenres, onGenreChange }) {
  const toggleGenre = (genreId) => {
    if (selectedGenres.includes(genreId)) {
      onGenreChange(selectedGenres.filter(g => g !== genreId));
    } else {
      onGenreChange([...selectedGenres, genreId]);
    }
  };

  return (
    <div className="genre-selector">
      <h3>🎵 选择音乐流派</h3>
      <div className="genre-grid">
        {GENRES.map(genre => (
          <button
            key={genre.id}
            className={`genre-btn ${selectedGenres.includes(genre.id) ? 'active' : ''}`}
            style={{
              '--genre-color': genre.color,
              borderColor: selectedGenres.includes(genre.id) ? genre.color : 'transparent',
              background: selectedGenres.includes(genre.id) ? `${genre.color}22` : 'var(--card-bg)'
            }}
            onClick={() => toggleGenre(genre.id)}
          >
            <span className="genre-label">{genre.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
